export default "__VITE_ASSET__aW0uq0Zf__"